<script lang="ts">
  // Abschnitt „Änderungen" im Baum des Bereichs Claude (baum.svelte.ts):
  // was im gezeigten Repo noch nicht gesichert ist -- offene Dateien wie in
  // VS Code mit M / A / D / R, darunter die Commits, die der Server noch
  // nicht hat (gelber Pfeil: ein Handgriff). Welches Repo, sagt der Kopf.
  // Ein Klick zeigt die Änderung (pages/ClaudeAenderung.svelte) als
  // Vorschau, Doppelklick heftet an.
  import Icon from "../Icon.svelte";
  import { getClaude } from "../claude-summary.svelte";
  import { t } from "../i18n.svelte";
  import { oeffnePfad } from "../shell/route-sync.svelte";
  import { istPfadAktiv } from "../shell/tabs.svelte";
  import { gezeigtesRepo } from "./baum.svelte";
  import { aenderungPfad, repoStandFuer } from "./claude";

  const repo = $derived(gezeigtesRepo());
  const rs = $derived(repoStandFuer(getClaude()?.stand, repo));
  const BUCHSTABE: Record<string, string> = { "geändert": "M", neu: "A", "gelöscht": "D", umbenannt: "R" };

  // „alt -> neu" bei Umbenennungen: der neue Name zählt
  function neuerPfad(pfad: string): string {
    return pfad.includes(" -> ") ? pfad.split(" -> ").pop()! : pfad;
  }
  function teile(pfad: string): { name: string; ordner: string } {
    const p = neuerPfad(pfad);
    const i = p.replace(/\/$/, "").lastIndexOf("/");
    return i < 0 ? { name: p, ordner: "" } : { name: p.slice(i + 1) || p, ordner: p.slice(0, i) };
  }
</script>

<div class="grid pb-2">
  {#if !rs}
    <p class="text-fg-subtle t-meta px-3 py-1" data-zeile>{t("claude.baum.kein_repo", "Kein Repo gewählt.")}</p>
  {:else if rs.fehler}
    <p class="text-danger t-meta px-3 py-1" data-zeile>{rs.fehler}</p>
  {:else if !rs.offen.length && !rs.ungepusht?.length}
    <p class="text-fg-subtle t-meta px-3 py-1" data-zeile>{t("claude.baum.nichts_offen", "Nichts offen, alles gepusht.")}</p>
  {:else}
    {#each rs.offen as d (d.pfad)}
      {@const n = teile(d.pfad)}
      {@const pfad = aenderungPfad(repo, { datei: neuerPfad(d.pfad) })}
      <button type="button" class="zeile" data-zeile class:aktiv={istPfadAktiv(pfad)} title={d.pfad} onclick={() => oeffnePfad(pfad, { vorschau: true })} ondblclick={() => oeffnePfad(pfad)}>
        <span class="art {BUCHSTABE[d.art] ?? 'M'}">{BUCHSTABE[d.art] ?? "M"}</span>
        <span class="truncate">{n.name}{#if n.ordner}<span class="ordner">{n.ordner}</span>{/if}</span>
      </button>
    {/each}
    {#if rs.offen_zahl > rs.offen.length}
      <p class="text-fg-subtle t-meta px-3 py-0.5" data-zeile>{t("claude.aend.mehr", "… und {n} weitere").replace("{n}", String(rs.offen_zahl - rs.offen.length))}</p>
    {/if}
    {#each rs.ungepusht ?? [] as c (c.hash)}
      {@const pfad = aenderungPfad(repo, { commit: c.hash })}
      <button type="button" class="zeile" data-zeile class:aktiv={istPfadAktiv(pfad)} title={`${c.kurz} · ${t("claude.aend.nicht_gepusht", "nicht gepusht")}`} onclick={() => oeffnePfad(pfad, { vorschau: true })} ondblclick={() => oeffnePfad(pfad)}>
        <span class="art pfeil"><Icon name="upload" size={12} /></span>
        <span class="truncate">{c.titel}</span>
      </button>
    {/each}
  {/if}
</div>

<style>
  /* Wie eine Baumzeile (TreeNode.svelte). */
  .zeile {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0;
    padding: 0.2rem 0.75rem 0.2rem 1.25rem;
    margin: 1px 0.35rem 1px 0;
    font-size: 0.84rem;
    color: var(--fg);
    text-align: left;
    border-radius: 0.4rem;
  }
  .zeile:hover {
    background: var(--bg-elev);
  }
  .zeile.aktiv {
    background: color-mix(in srgb, var(--fg) 11%, transparent);
    font-weight: 600;
  }
  .ordner {
    margin-left: 0.4rem;
    font-size: 0.72rem;
    font-weight: 400;
    color: var(--fg-subtle);
  }
  .art {
    width: 0.8rem;
    flex: none;
    display: grid;
    place-items: center;
    font-family: var(--font-mono, ui-monospace, monospace);
    font-size: 0.7rem;
    font-weight: 600;
    color: var(--fg-subtle);
  }
  .art.M {
    color: color-mix(in oklab, var(--warning) 75%, var(--fg));
  }
  .art.A {
    color: var(--success);
  }
  .art.D {
    color: var(--danger);
  }
  .art.pfeil {
    color: var(--warning);
  }
</style>
